export default "__VITE_ASSET__37e7ee16__"